var React = require('react');

function Download (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M16 11H21L12 21L3 11H8V0H16V11ZM17 22H7V24H17V22Z","fill":"currentColor"}));
}

Download.defaultProps = {"viewBox":"0 0 24 24","fill":"none","style":{"color":"#39424A"}};

module.exports = Download;

Download.default = Download;
